// extracted by mini-css-extract-plugin
module.exports = {"progress":"vertical-carousel_progress__S5Ttj","active":"vertical-carousel_active__4oHyu"};